import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useCreative } from '../hooks/creative/useCreative';

/**
 * Protected route wrapper that ensures only the owner of a creative
 * can access editing pages. Redirects non-owners to the member page.
 */
const CreativeOwnerRoute = ({ children }) => {
  const { id: creativeId } = useParams();
  const { user: currentUser } = useSelector((state) => state.auth || {});
  const currentUserId = currentUser?._id || currentUser?.id;
  
  const { creative, loading, error } = useCreative(creativeId);
  
  // Show loading state while checking ownership
  if (loading) {
    return null; // Or a loading spinner
  }
  
  // If error or no creative found, redirect
  if (error || !creative) {
    return <Navigate to="/services-studios" replace />;
  }
  
  // Check if current user is the owner
  const isOwner = currentUserId && creative?.userID && currentUserId === creative.userID;
  
  // If not owner, redirect to member page (public view)
  if (!isOwner) {
    return <Navigate to={`/members/${creativeId}`} replace />;
  }
  
  // Owner confirmed, render children
  return children;
};

export default CreativeOwnerRoute;

